<template>
    <v-card class="elevation-1">
        <v-toolbar flat height="37">
            <span class="primary--text font-weight-bold">QUICK ACTIONS</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
            <v-chip v-for="(item, index) in quickactions" :key="index" @click="$router.push(`${item.actionPath}`)" >
                <v-icon>{{ item.actionIcon }}</v-icon>
                <span class="ml-5 clickable">{{ item.actionName }}</span>
            </v-chip>
        </v-card-text>
    </v-card>
</template>

<script>
export default {     
    name: 'QuickActions',
    data () {
        return {
            error: false,
            errorMessage: '',
            loading: false,

            // static data for faster rendering
            quickActionMaster: [
                {
                    actionCode: "FILE_LEAVE",
                    actionName: "File Time Off",
                    actionIcon: "work_off",
                    actionPath: "/myattendance/timeoff",
                    themeIds: [1, 2, 3]
                },
                {
                    actionCode: "APPLY_OVERTIME",
                    actionName: "Apply Overtime",
                    actionIcon: "far fa-calendar-plus",
                    actionPath: "/myattendance/overtime",
                    themeIds: [1, 2, 3]
                },
                {
                    actionCode: "ATTENDANCE_CORRECTION",
                    actionName: "Attendance Correction",
                    actionIcon: "far fa-calendar-check",
                    actionPath: "/myattendance/corrections",
                    themeIds: [1, 2, 3]
                },
                {
                    actionCode: "VIEW_TIMESHEET",
                    actionName: "View Timesheet",
                    actionIcon: "content_paste",
                    actionPath: "/myattendance/timesheet",
                    themeIds: [1, 2, 3]
                },
                {
                    actionCode: "VIEW_PAYSLIP",
                    actionName: "View Payslip",
                    actionIcon: "fa-wallet",
                    actionPath: "/payroll/mypayslip",
                    themeIds: [1, 2, 3]
                },
                {
                    actionCode: "TEAM_STATUS",
                    actionName: "Team Attendance Today",
                    actionIcon: "access_time",
                    actionPath: "/myteam/attendance",
                    themeIds: [2, 3, 4, 5]
                },
                {
                    actionCode: "TEAM_TIMESHEETS",
                    actionName: "Team Timesheets",
                    actionIcon: "content_paste",
                    actionPath: "/myteam/timesheet",
                    themeIds: [2, 3]
                },

                {
                    actionCode: "CASH_ADVANCE",
                    actionName: "Cash Advance",
                    actionIcon: "add_card",
                    actionPath: "/finance/mycashadvances",
                    themeIds: [1, 2, 3]
                },
                {
                    actionCode: "REIMBURSEMENT",
                    actionName: "File Reimbursement",
                    actionIcon: "redeem",
                    actionPath: "/finance/myreimbursements",
                    themeIds: [1, 2, 3]
                }
            ]
        }
    },
    computed: {
        savedThemeId() {
            if (this.$store.state.dashboardTheme && this.$store.state.dashboardTheme.theme) {
                return this.$store.state.dashboardTheme.theme.themeId
            }
        },
        quickactions() {
            const themeId = this.savedThemeId

            return this.quickActionMaster.filter(x => {
                return x.themeIds.includes(themeId)
            })
        }
    }
}
</script>